export function AlertsDao(XRAY_RESOURCE, XRayUIDaoFactory) {
    return XRayUIDaoFactory()
        .setPath(XRAY_RESOURCE.ALERTS + '/:param')
        .setCustomActions({
            'get': {
                method: 'GET'
            },
            'getIssueDetailsForAlert': {
                method: 'GET'
            },
            'getSingle': {
                method: 'GET',
                params: {param: '@alertID'}
            },
            'delete': {
                method: 'DELETE',
                params: {param: '@alertID'}
            },
            'acknowledge': {
                method: 'POST',
                params: {param: 'ignore'}
            },
            'acknowledgeAll': {
                method: 'POST',
                params: {allusers: '@allusers'},
                path: XRAY_RESOURCE.ALERTS + '/ignoreAllAlerts/:params'
            },
            'getFiltered': {
                method: 'GET',
                path: XRAY_RESOURCE.ALERTS + '/getByIds'
            },
            'getCount': {
                method: 'GET',
                path: XRAY_RESOURCE.ALERTS + '/count/alerts'
            }
        })
        .getInstance();
}



// WEBPACK FOOTER //
// ./modules/xray/data/dao/alerts_dao.js